import "./App.scss";
import "./App.less";
import React, {useMemo, Suspense} from 'react';
import {Switch, Route}                                    from "react-router-dom";
import {Layout}                                           from 'antd';
import pages                                              from "@page/index.js";
import pageList                                           from "@tools/page_list_no_login";
import LoadingPage                                        from "@components/loading_page/LoadingPage";


const { Content } = Layout;

const App = () => {
    let allowPages = pageList;
    const NotFound = useMemo(() => pages.not_found, []);

    return (
            <Layout>
                <Content>
                    <Suspense fallback={<LoadingPage />}>
                        <Switch>
                            {
                                allowPages.map(({ url, id }) => {
                                    const Page = pages[ id ] || NotFound;
                                    return (
                                        <Route
                                            path={url}
                                            key={id}
                                        >
                                            <Page />
                                        </Route>
                                    )
                                })
                            }
                            <Route path="*">
                                <NotFound />
                            </Route>
                        </Switch>
                    </Suspense>
                </Content>
            </Layout>
    )
};

export default App
